var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 3.08031C3.95922 3.08031 4.83922 1.32031 6.59922 1.32031C8.35922 1.32031 9.23922 3.08031 10.9992 3.08031C12.7592 3.08031 13.6392 1.32031 15.3992 1.32031C17.1592 1.32031 18.0392 3.08031 19.7992 3.08031M2.19922 8.36031C3.95922 8.36031 4.83922 6.60031 6.59922 6.60031C8.35922 6.60031 9.23922 8.36031 10.9992 8.36031C12.7592 8.36031 13.6392 6.60031 15.3992 6.60031C17.1592 6.60031 18.0392 8.36031 19.7992 8.36031M2.19922 18.9203C3.95922 18.9203 4.83922 17.1603 6.59922 17.1603C8.35922 17.1603 9.23922 18.9203 10.9992 18.9203C12.7592 18.9203 13.6392 17.1603 15.3992 17.1603C17.1592 17.1603 18.0392 18.9203 19.7992 18.9203M2.19922 13.6403C3.95922 13.6403 4.83922 11.8803 6.59922 11.8803C8.35922 11.8803 9.23922 13.6403 10.9992 13.6403C12.7592 13.6403 13.6392 11.8803 15.3992 11.8803C17.1592 11.8803 18.0392 13.6403 19.7992 13.6403",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowimg);
export default __webpack_public_path__ + "static/media/flowimg.2610bfa0b6496fb579c6cea9fbf0e50c.svg";
export { ForwardRef as ReactComponent };